import {Box, Typography} from "@mui/material";
import Copyright from "./components/copyright.component";
import LoginForm from "./components/form.component";
import ABKHeader from "./components/abk-header.component";
import {colors} from "../../theme";
import useClientQuery from "../../global/queries/useClientQuery";
import {Navigate} from "react-router-dom";

function LoginScreen() {


    const {isSuccess} = useClientQuery();

    if (isSuccess) return <Navigate to="/" />

    return (
        <main style={{height: '100vh', display: 'flex'}}>
            <Box
                sx={{
                    flex: 1,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    height: '100%'
                }}
            >
                <div>
                    <ABKHeader/>
                    <LoginForm/>
                    <Copyright/>
                </div>
            </Box>
            <div className="right" style={{
                flex: 1,
                display: "flex",
                backgroundColor: colors.gruen,
                alignItems: "center",
                justifyContent: "center",
                backgroundPosition: 'center',
                backgroundSize: 'auto',
                backgroundRepeat: 'no-repeat'
            }}
            >
                <Box sx={{ padding: 7, backgroundColor: "white", margin: 7 }}>
                    <Typography color="primary" variant="h5" >Ihr Zugang zum ABK Kundenportal</Typography>
                    <br/>
                    <Typography align="justify" variant="body1" >Sie möchten sich über Ihre bestehende Lizenzen informieren, Ihre ABK-Bausteine einsehen oder Ihre Kontaktdaten verwalten? Dann sind Sie hier richtig!</Typography>
                    <br/>
                    <Typography align="justify" variant="body1" >Nach Eingabe Ihrer ABK-Nummer und dem Lizenzschlüssel - zu finden auf Ihrer Nutzungsbewilligung - haben Sie Zugriff auf diese Informationen.</Typography>
                </Box>
            </div>
        </main>
    );
}

export default LoginScreen;
